import React, { useState } from 'react';
import { HelpCircle, ChevronDown, Mail, MessageCircle } from 'lucide-react';

interface FaqItem {
  question: string;
  answer: string;
}

const FAQS: FaqItem[] = [
  {
    question: 'How does the Bonus Reward work?',
    answer: "Once your order is delivered and the supplier's invoice is verified as compliant, we credit a Bonus Reward calculated from the invoice amount. It's added to your Reward Balance and can be used to pay for future orders or shipping fees. Orders shipped to a UK-domestic address don't qualify.",
  },
  {
    question: 'How is the international shipping fee calculated?',
    answer: 'After your order is purchased, our team packs it and enters the real carrier cost on your behalf. If you pay that fee by card, a 3% processing surcharge is added; bank transfer and Reward Balance have no markup.',
  },
  {
    question: 'What is the Procurement Partner Program?',
    answer: 'It\'s an optional program where approved members receive a dedicated Visa card to shop directly and earn a higher cashback rate. Apply from Settings > Partner Program Card — approval requires KYC verification and a £13 refundable administration hold on your card.',
  },
  {
    question: 'Can I edit or cancel an order after submitting it?',
    answer: "Orders can be edited or deleted while they're still in 'Pending Pre-Auth' status, from the Smart Orders page. Once an order has been confirmed and purchased, contact support to make changes.",
  },
  {
    question: 'How do I manage my saved shipping addresses and cards?',
    answer: 'Go to Settings > Shipping Addresses to add, edit, or remove saved delivery addresses, and Settings > Payment Cards to manage saved cards. One address and one card are always marked as your default.',
  },
];

const HelpCenter: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div>
      <h1 className="page-title" style={{ marginBottom: '32px' }}>Help Center</h1>

      <div style={{ display: 'grid', gap: '32px' }}>
        <div className="section-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
            <HelpCircle size={20} className="text-primary" />
            <h3 className="card-title" style={{ margin: 0 }}>Frequently Asked Questions</h3>
          </div>
          <div style={{ display: 'grid', gap: '10px' }}>
            {FAQS.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={faq.question} style={{ border: '1px solid var(--border-light)', borderRadius: '6px', overflow: 'hidden' }}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    style={{
                      width: '100%', textAlign: 'left', padding: '14px 16px', background: 'var(--bg-oatmeal)',
                      border: 'none', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', fontSize: '14px', fontWeight: 600,
                    }}
                  >
                    {faq.question}
                    <ChevronDown size={16} style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s', flexShrink: 0 }} />
                  </button>
                  {isOpen && (
                    <div style={{ padding: '14px 16px', fontSize: '13px', color: '#64748B', lineHeight: 1.6 }}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className="section-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <MessageCircle size={20} className="text-primary" />
            <h3 className="card-title" style={{ margin: 0 }}>Still Need Help?</h3>
          </div>
          <p style={{ fontSize: '13px', color: '#64748B', marginBottom: '16px' }}>
            Our support team typically responds within 1-2 business days.
          </p>
          <a href="mailto:support@incord.uk" className="btn btn-outline" style={{ width: 'fit-content', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
            <Mail size={14} /> support@incord.uk
          </a>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
